import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../FishFinderBuilder.css';

function LandingPage() {
  const navigate = useNavigate();

  const handleBuildBundle = () => {
    navigate('/BuildMyFishFinder');
  };

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <h1>Find Your Perfect Fishing Electronics</h1>
          <p>Build custom LiveScope bundles, find the right screen, or discover today's best deals</p>
        </div>
      </div>

      {/* Main Options Section */}
      <h2 className="what-are-you-looking-for">What Are You Looking For Today?</h2>
      
      <div className="options-grid">
        {/* Custom Fish Finder Builder */}
        <Link to="/custom-builder" className="option-card">
          <div className="option-icon">
            <img src="/images/screens/garmin-gpsmap-8612xsv.jpg" alt="Fish Finder Builder" className="category-icon" />
          </div>
          <h3>Custom Fish Finder Builder</h3>
          <p>Build your perfect setup piece by piece with our interactive builder tool</p>
        </Link>
        
        {/* Screen Selector */}
        <Link to="/compare-screens" className="option-card">
          <div className="option-icon">
            <img src="/images/68798-Chartplotter-Blog-header-image.webp" alt="Screen" className="category-icon" />
          </div>
          <h3>Find the Right Screen</h3>
          <p>Compare display units to find the perfect one for your boat</p>
        </Link>
        
        {/* Battery Guide */}
        <Link to="/select/battery" className="option-card">
          <div className="option-icon">
            <img src="/images/batteries/amped-30ah-battery.webp" alt="Battery" className="category-icon" />
          </div>
          <h3>Battery Guide</h3>
          <p>Determine the right battery for your LiveScope and fishing needs</p>
        </Link>
        
        {/* Bundle Builder */}
        <Link to="/custom-builder" className="option-card">
          <div className="option-icon">
            <img src="/images/GPS-GEMU295LSB_0.webp" alt="LiveScope" className="category-icon" />
          </div>
          <h3>Build a LiveScope Bundle</h3>
          <p>Customize your complete LiveScope setup with compatible components</p>
        </Link>
      </div>

      {/* Hot Deals Section */}
      <div className="hot-deals-section">
        <h2>Today's Hottest Deals</h2>
        <p>Limited-time offers on top fishing electronics - updated daily</p>
        
        <div className="deals-grid">
          {/* Deal 1 */}
          <div className="deal-card">
            <div className="deal-badge">HOT DEAL</div>
            <div className="deal-image">
              <img src="/images/screens/garmin-echomap-uhd2-93sv.jpg" alt="Garmin Echomap UHD2 93sv" />
            </div>
            <div className="deal-content">
              <h3>Garmin Echomap UHD2 93sv - $200 Off</h3>
              <div className="deal-price">
                <span className="regular-price">$1,199.99</span>
                <span className="sale-price">$999.99</span>
              </div>
              <div className="deal-savings">
                Save $200.00
              </div>
              <div className="deal-expiry">
                Offer ends: July 30, 2023
              </div>
              <a 
                href="https://www.youraffiliatelink.com/echomap-93sv-deal" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="deal-button"
              >
                Claim This Deal
              </a>
            </div>
          </div>

          {/* Deal 2 */}
          <div className="deal-card">
            <div className="deal-badge">HOT DEAL</div>
            <div className="deal-image">
              <img src="/images/screens/garmin-gpsmap-1042xsv.jpg" alt="LiveScope Plus LVS34" />
            </div>
            <div className="deal-content">
              <h3>LiveScope Plus LVS34 Bundle - Limited Time Offer</h3>
              <div className="deal-price">
                <span className="regular-price">$1,599.99</span>
                <span className="sale-price">$1,399.99</span>
              </div>
              <div className="deal-savings">
                Save $200.00
              </div>
              <div className="deal-expiry">
                Offer ends: July 25, 2023
              </div>
              <a 
                href="https://www.youraffiliatelink.com/livescope-bundle-deal" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="deal-button"
              >
                Claim This Deal
              </a>
            </div>
          </div>

          {/* Deal 3 */}
          <div className="deal-card">
            <div className="deal-badge">HOT DEAL</div>
            <div className="deal-image">
              <img src="/images/screens/garmin-echomap-ultra2-126sv.jpg" alt="Garmin ECHOMAP Ultra 126sv" />
            </div>
            <div className="deal-content">
              <h3>Garmin ECHOMAP Ultra 126sv - 15% OFF</h3>
              <div className="deal-price">
                <span className="regular-price">$2,249.99</span>
                <span className="sale-price">$1,912.49</span>
              </div>
              <div className="deal-savings">
                Save $337.50
              </div>
              <div className="deal-expiry">
                Offer ends: August 5, 2023
              </div>
              <a 
                href="https://www.youraffiliatelink.com/ultra-126sv-deal" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="deal-button"
              >
                Claim This Deal
              </a>
            </div>
          </div>
        </div>
        
        <div className="view-all-deals">
          <Link to="/deals" className="view-all-button">View All Deals</Link>
        </div>
      </div>

      {/* Compare Section */}
      <div className="comparison-section">
        <h2>Compare Garmin Chartplotters</h2>
        
        <p>
          <strong>Not sure which model to choose?</strong> Our comparison breaks down the differences between ECHOMAP UHD, ULTRA, and GPSMAP series to find your perfect LiveScope-capable unit.
        </p>
        
        <p className="watch-text">
          👉 Watch to see all 42 Garmin chartplotters compared!
        </p>
        
        <div className="comparison-video">
          <a 
            href="https://www.youtube.com/watch?v=gZlc7O7ZIZk" 
            target="_blank"
            rel="noopener noreferrer"
            className="video-thumbnail"
          >
            <img 
              src="https://img.youtube.com/vi/gZlc7O7ZIZk/maxresdefault.jpg" 
              alt="Garmin Chartplotter Comparison"
              className="youtube-thumbnail"
            />
            <div className="play-button">
              <div className="play-triangle"></div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default LandingPage; 